export const VIEW_COLUMNS = {
  PRODUCT_NAME: {
    id: 'product_name',
    label: 'Product Name',
  },
  SKU: {
    id: 'sku',
    label: 'SKU',
  },
  UPC: {
    id: 'upc',
    label: 'UPC',
  },
  QTY: {
    id: 'total_qty',
    label: 'Qty',
  },
  AVAILABLE_TO_SELL: {
    id: 'qty_available',
    label: 'Available To Sell',
  },
  SHIP_TYPES: {
    id: 'ship_types',
    label: 'Ship Types',
  },
  LEAD_TIME: {
    id: 'lead_time',
    label: 'Lead Time',
  },
  COST: {
    id: 'cost',
    label: 'Cost',
  },
  TOTAL_COST: {
    id: 'total_cost',
    label: 'Total Cost',
  },
  PRICE: {
    id: 'price',
    label: 'Price',
    tooltip: 'Lorem ipsum',
  },
  TOTAL_PRICE: {
    id: 'total_price',
    label: 'Total Price',
    tooltip: 'Lorem ipsum',
  },
};